import { createContext, useCallback, useContext, useRef, useState } from "react";
import BookingModal from "@/components/np/BookingModal";

const BookingContext = createContext({ openBooking: () => {} });

export const BookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  const openBooking = useCallback(() => {
    triggerRef.current = document.activeElement;
    setOpen(true);
  }, []);
  const restoreFocus = useCallback((e) => {
    const el = triggerRef.current;
    if (el && el.isConnected && el !== document.body) {
      e.preventDefault();
      el.focus();
    }
  }, []);
  return (
    <BookingContext.Provider value={{ openBooking }}>
      {children}
      <BookingModal open={open} onOpenChange={setOpen} onCloseAutoFocus={restoreFocus} />
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
